import { useState } from 'react';
import { RISK_FAQ } from '@/mocks/risk';

export default function QuickAnswers() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="rounded-3xl border border-slate-200/80 bg-white p-6 md:p-8">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-violet-50 px-3 py-1 text-xs font-semibold text-violet-700 ring-1 ring-violet-100">
          <span className="h-1.5 w-1.5 rounded-full bg-violet-500" />
          Hỏi nhanh
        </span>
        <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-slate-900 md:text-3xl">
          Quick Answers
        </h2>
      </div>

      <div className="mt-6 space-y-3">
        {RISK_FAQ.map((item, i) => {
          const isOpen = open === i;
          return (
            <div key={item.q} className="overflow-hidden rounded-2xl border border-slate-200/80 bg-slate-50/50">
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                className="flex w-full items-center gap-3 px-5 py-4 text-left"
              >
                <span className="flex-1 text-sm font-semibold text-slate-800">{item.q}</span>
                <span
                  className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                    isOpen ? 'bg-violet-600 text-white' : 'bg-slate-200 text-slate-500'
                  }`}
                >
                  <i className={`ri-add-line text-base transition-transform ${isOpen ? 'rotate-45' : ''}`} />
                </span>
              </button>
              {isOpen && (
                <div className="border-t border-slate-200/70 px-5 py-4">
                  <p className="text-sm leading-relaxed text-slate-600">{item.a}</p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}